<template>
  <div style="text-align: center">
    <img style="width: 90%" :src="host+qr"/>
    <!--<div>-->
    <!--  请扫二维码，添加客服微信！-->
    <!--</div>-->
  </div>
</template>

<script>
export default {
  name: "Waiter",
  data(){
    return{
      host:process.env.VUE_APP_API_HOST,
      qr:'',
    }
  },
  methods:{
    getQr(){
      this.$myGetHttp(this.$myUrl.qr).then(res=>{
        console.log(res)
        this.qr = res.records.qr
      })
    }

  },

  mounted() {
    this.getQr()
  }

}
</script>

<style scoped>

</style>
